//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'loadedTip',
    props: {
        tipText: String
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
